import { defineMessages } from 'react-intl';

export const GridItemTypes = Object.freeze({
  playlist: 'playlistBy',
  album: 'fromAlbum',
  thumbprint: 'thumbedUpOn',
});

export const GridItemText = defineMessages({
  moreText: {
    id: 't.more',
    defaultMessage: 'More',
  },
  playlistBy: {
    id: 't.playlistBy',
    defaultMessage: 'Playlist by',
  },
  fromAlbum: {
    id: 't.fromAlbum',
    defaultMessage: 'From the album',
  },
  thumbedUpOn: {
    id: 't.thumbedUpOn',
    defaultMessage: 'Thumbed Up on',
  },
  viewText: {
    id: 't.view',
    defaultMessage: 'View',
  },
});
